<template>
  <div v-loading="loading">
    <Form>
      <FormItem :label="l('JIHUAMINGCHENG')">{{item.name}}</FormItem>
      <Row>
        <Col span="8">
          <FormItem :label="l('NIANDU')">{{item.year}}{{l("NIAN")}}</FormItem>
        </Col>
        <Col span="8">
          <FormItem :label="l('SUOSHUZUZHI')">{{item.domainName}}</FormItem>
        </Col>
        <Col span="8">
          <FormItem :label="l('GUANLIWEIDU')">{{item.dimensionNames}}</FormItem>
        </Col>
      </Row>
      <Row class="m-b">
        <Col span="8">
          <FormItem :label="l('YUSUANHEJI')">{{item.sumExpenseBudget}}</FormItem>
        </Col>
        <Col span="8">
          <FormItem :label="l('RENCIHEJI')">{{item.sumExpectedPeoples}}</FormItem>
        </Col>
        <Col span="8">
          <FormItem :label="l('KESHIHEJI')">{{item.sumExpectedClassHours}}</FormItem>
        </Col>
      </Row>
      <table class="plan-table">
        <tr>
          <th>{{l("PEIXUNZHUYAONEIRONG")}}</th>
          <th>{{l("PEIXUNDUIXIANG")}}</th>
          <th>{{l("KECHENGMULU")}}</th>
          <th>{{l("PEIXUNXINGSHI")}}</th>
          <th>{{l("PEIXUNLEIXING")}}</th>
          <th>{{l("KAOHEFANGSHI")}}</th>
          <th>{{l("FEIYONGYUSUAN")}}</th>
          <th>{{l("JIHUARENSHU")}}</th>
          <th>{{l("JIHUAKESHI")}}</th>
          <th>{{l("PEIXUNYUEFEN")}}</th>
          <th>{{l("JIANGSHI")}}</th>
        </tr>
        <tr v-for="(i,index) in item.planDetailList" :key="index">
          <td>{{i.trainingContent}}</td>
          <td>{{i.trainObject}}</td>
          <td>{{i.courseTypeName}}</td>
          <td>{{i.trainFormName}}</td>
          <td>{{i.trainTypeName}}</td>
          <td>{{i.testMethodName}}</td>
          <td>{{i.expenseBudget}}{{l("YUAN")}}</td>
          <td>{{i.expectedPeoples}}</td>
          <td>{{i.expectedClassHours}}</td>
          <td>
            <span v-for="(month,index) in i.months" :key="index">{{month}}{{l("YUE")}},</span>
          </td>
          <td>{{i.teacherNames}}</td>
        </tr>
      </table>
    </Form>
  </div>
</template>

<script>
export default {
  name: "yearPlan",
  props: ["id"],
  data() {
    return {
      loading: false,
      item: {}
    };
  },
  methods: {
    _fetch(id) {
      if (id) {
        this.loading = true;
        this.http
          .request("sys/trainYearPlan/info", { id: id })
          .then(result => {
            this.item = result.item;
          })
          .finally(() => (this.loading = false));
      }
    }
  },
  created: function() {
    this._fetch(this.id);
  }
};
</script>

<style scoped>
.ivu-form-item {
  margin-bottom: 0px;
  vertical-align: top;
  zoom: 1;
}
.plan-table {
  width: 100%;
}
.plan-table th {
  text-align: left;
  padding: 3px;
  border: 1px solid #eeeeee;
}
.plan-table td {
  text-align: left;
  height: 25px;
  line-height: 25px;
  padding: 3px;
  border: 1px solid #eeeeee;
}
</style>



// WEBPACK FOOTER //
// yearPlan.vue?1db48486